import ExceptionHandling from './ExceptionHandling.js'
import { useStore, ActionTypes } from "../store";
import instance from './index';

export default class SmsService {
	getItems(storeID,start) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/sms_settings_list';
		const formData = new FormData();
		formData.append('start', start);
		formData.append('storeID', storeID);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
		.catch((e) => ExceptionHandling.HandleErrors(e))
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}

	saveItem(postObj,stateObj) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/add_sms_settings';
		const formData = new FormData();
		formData.append('enable_notification', stateObj.enableNotification);
		formData.append('domain_name', stateObj.domainName);
		formData.append('account_email', stateObj.accountEmailAddress);
		formData.append('token_key', stateObj.tokenKey);
		formData.append('test_no', stateObj.testMobileNo);
		formData.append('branch_id', postObj.selectedStore);
		formData.append('status', postObj.status);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	updateItem(postObj,stateObj) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/edit_sms_settings';
		const formData = new FormData();
		formData.append('id', postObj.id);
		formData.append('enable_notification', stateObj.enableNotification);
		formData.append('domain_name', stateObj.domainName);
		formData.append('account_email', stateObj.accountEmailAddress);
		formData.append('token_key', stateObj.tokenKey);
		formData.append('test_no', stateObj.testMobileNo);
		formData.append('branch_id', postObj.selectedStore);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	getItem(data) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/get_sms_settings/' + data.id;
		return instance().get(api)
			.then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	changeStatus(postObj) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/delete_sms_settings';
		const formData = new FormData();
		formData.append('id', postObj.id);
		formData.append('status', postObj.status);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	updateSmsPackage(data) {
        const store = useStore(); // Access Vuex store
        store.dispatch(ActionTypes.PROGRESS_BAR, true); // Show progress bar
        const api = '/api/edit_sms_package'; // API endpoint
        return instance()(
            {
                method: 'post',
                url: api,
                data: data,
                   // Data sent to the server
            }
        )
            .then((res) => res.data) // Return the response data
            .catch((e) => ExceptionHandling.HandleErrors(e)) // Handle errors
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false); // Hide progress bar
            });
    }
}